import Env from '../base/env'

export default class SearchPopin
{
    constructor()
    {
        const $trigger = document.querySelector('.jsSearch--trigger')
        const $triggerTouch = document.querySelector('.jsSearch--touch')
        const $searchField = document.querySelector('.jsSearch--field')
        if($trigger != null) {
            const $viewer = document.querySelector('.jsSearch--view')
            $trigger.addEventListener('click',()=>{
                Env.$html.classList.add('search--isOpened')
                $searchField.focus()
            })
            $triggerTouch.addEventListener('click',()=>{
                Env.$html.classList.add('search--isOpened')
                $searchField.focus()
            })
            $viewer.querySelector('.jsClose').addEventListener('click',()=>{
                Env.$html.classList.remove('search--isOpened')
            })
        }
    }
}